/**
 * Вид записи справочника внешних держателей — зеркало App\Enums\InventoryHolderType.
 *
 * Сотрудника SD здесь нет: он хранится в inventory_items.responsible_person_id
 * ссылкой на accounts и записи в справочнике не имеет.
 */
export default class InventoryHolderType {
    static EXTERNAL = 0;
    static EXPECTED = 1;
}
